import { PageStorageRestoreError } from "@/libs/page/errors";

export interface PageSecretPasswordLoginState {
  uuid: string;
  isLogin: boolean;
}

export default function pageSecretLoginStorage(storageKey: string) {
  /**
   * セッションストレージからの取得
   */
  const get = (): Promise<PageSecretPasswordLoginState | undefined> => {
    const json = window.sessionStorage.getItem(storageKey);
    if (!json) {
      return Promise.resolve(undefined);
    }

    const stateFromJson = JSON.parse(json) as {
      uuid: string;
      isLogin: boolean;
    };

    const state = {
      ...stateFromJson,
    };

    return Promise.resolve(state as PageSecretPasswordLoginState);
  };

  /**
   * セッションストレージへのセット
   */
  const set = (data: PageSecretPasswordLoginState) => {
    const json = JSON.stringify(data);
    window.sessionStorage.setItem(storageKey, json);
    return Promise.resolve();
  };

  /**
   * 取得を試み、存在しなければエラーを投げる
   */
  const tryGet = async (): Promise<PageSecretPasswordLoginState> => {
    const state = await get();
    if (!state) {
      throw new PageStorageRestoreError(
        `入力値がありません。key=${storageKey}`,
      );
    }
    return state;
  };

  return {
    get,
    tryGet,
    set,
  };
}
